import { NgHttpCachingConfig, NgHttpCachingStrategy } from 'ng-http-caching';

export const RESPONSIVE_CONFIG = {
  MIN_WIDTH: 768,
  MIN_SIDEBAR_WIDTH: 350,
};

export const CUSTOM_ICONS_PACK = 'custom-icons';

export const MAX_PRESET_NAME_LENGTH = 8;

export const DEFAULT_PER_PAGE_OFFSET = 8;

export const DEFAULT_LIST_PAGE_OFFSETS = [DEFAULT_PER_PAGE_OFFSET, 10, 20, 50];

export const THUMBNAIL_PLACEHOLDER = 'assets/svg/model-thumbnail.svg';

export const ERRORS_RESPOND_ARRAY = [
  'Cannot delete process in progress. Please wait for process to finish.',
  'Cannot delete process - worker is being deployed. Please wait for process to finish',
];

export const ERRORS_RESPOND_PROCESSES_ARRAY = [
  'Cannot delete process - worker is being deployed. Please wait for process to finish',
  'Cannot delete process in progress. Please wait for process to finish.',
];

export const HTTP_CACHING_CONFIG: NgHttpCachingConfig = {
  cacheStrategy: NgHttpCachingStrategy.DISALLOW_ALL,
  isValid: (entry) => entry.response.status === 200,
};

export const SKYFISH_DOCS = {
  'Terms of Service': 'assets/documents/skyfish-tos-7-26-23.pdf',
  'End-User License Agreement': 'assets/documents/skyportal-eula.pdf',
  'Privacy Policy': 'assets/documents/skyportal-privacy-policy-7-26-23.pdf',
};

export const PROGRESS_BAR_COLOR = '#f56811';

export const AUTOMAPPING_FOLDER_DEFAULT_NAME = 'auto-generated';

export const REPORT_FILE_NAME = 'report';

export const ANALYTICS_FILE_NAME = 'analytics';
